import brochurePdf from "../../assets/doc/geniussemifinal.pdf";
import { resolveAsset } from "../content/resolveAsset";

export const downloadBrochurePdf = (pdfAsset) => {
  const url = pdfAsset ? resolveAsset(pdfAsset) : brochurePdf;
  const fileName =
    (pdfAsset && typeof pdfAsset === "object" && pdfAsset.fileName) || "Genius-Brochure.pdf";

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.rel = "noopener";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
